import React from 'react';
import { Pressable } from 'react-native';

import { Box, Text } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';
import theme from '@themes/theme';

type Props = { onDismiss: () => void };

export const NoTasksBanner: React.FC<Props> = ({ onDismiss }) => (
  <Box
    backgroundColor='blueMild'
    borderWidth={1}
    borderColor='blue'
    borderRadius='s'
    flexDirection='row'
    alignItems='center'
    m='m'
    p='m'
    style={{ gap: theme.spacing.s }}>
    <Icon name='Hash' variant='l' color='blue' />
    <Text variant='labelLarge' color='textPrimary' flex={1}>
      You&apos;ll be assigned tasks here — check back soon.
    </Text>
    <Pressable onPress={onDismiss} accessibilityLabel='Dismiss banner'>
      <Icon
        name='Close'
        width={12}
        height={12}
        padding='xxs'
        color='textPrimary'
      />
    </Pressable>
  </Box>
);
